import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./VideoLightbox.module.scss";

function VideoLightbox({ open, videoId, onClose = () => {} }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label="Close video"
      >
        &times;
      </button>
      <div className={styles.frameWrapper} onClick={(e) => e.stopPropagation()}>
        <iframe
          className={styles.frame}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          title="Elixir by Elchemy"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>,
    document.body
  );
}

export default VideoLightbox;
